import type { VacationApprovalDecisionKind } from '../../models/vacationApproval.types';

interface DecisionCopy {
    title: string;
    description: string;
    noteLabel: string;
    notePlaceholder: string;
    confirmLabel: string;
    confirmClassName: string;
}

export const DECISION_COPY: Record<VacationApprovalDecisionKind, DecisionCopy> = {
    approve: {
        title: 'Aprovar solicitação',
        description:
            'Ao aprovar, a solicitação segue para validação do DP.\nO colaborador será notificado da aprovação.',
        noteLabel: 'Observação para o DP (opcional)',
        notePlaceholder: 'Ex.: cobertura do time já combinada com a squad.',
        confirmLabel: 'Confirmar aprovação',
        confirmClassName: 'bg-primary-500 hover:bg-primary-600 focus-visible:outline-primary-500',
    },
    reject: {
        title: 'Reprovar solicitação',
        description:
            'A reprovação encerra esta solicitação.\nO colaborador será notificado da reprovação.',
        noteLabel: 'Motivo da reprovação',
        notePlaceholder: 'Descreva o motivo da reprovação.',
        confirmLabel: 'Confirmar reprovação',
        confirmClassName: 'bg-red-600 hover:bg-red-700 focus-visible:outline-red-600',
    },
};

export const CANCEL_LABEL = 'Cancelar';
